import type { StoreState } from '../state/types';
import type { User } from './types';

export const selectUser = (state: StoreState): User | undefined => {
  if (!state?.user) return undefined;
  return (Object.keys(state.user).length ? state.user as User : undefined);
};
